<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M15 6a6 6 0 0 1 6 6v4.5h.75a.75.75 0 1 1 0 1.5h-6.095a3.001 3.001 0 0 1-5.81 0H3a1.5 1.5 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 3 6h12zm-2.25 9.75a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-6-8.25h-3a.75.75 0 0 0-.745.663L3 8.25v3c0 .385.29.702.663.745L3.75 12h3a.75.75 0 0 0 .745-.663l.005-.087v-3a.75.75 0 0 0-.75-.75zm8.214 0H9.75a.75.75 0 0 0-.745.663L9 8.25v3c0 .385.29.702.663.745L9.75 12h9.714l-.003-.169A4.5 4.5 0 0 0 14.964 7.5z"
      :fill="disabled ? '#ccccc9' : '#1D1D20'"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
